import { makeAutoObservable, runInAction } from 'mobx'
import { nanoid } from 'nanoid'
import modalStore from 'shared/ui/Modal/store/modalStore'
import { logger } from 'shared/lib'
import { ContactsApi } from 'entities/Contacts'
import { type IParamsFiltersList } from 'entities/Broadcast/api/types'
import { ActivateWorkflowModalUi } from 'pages/workflows/ui/ActivateWorkflowModal/ui/ActivateWorkflowModalUi'

export type IParamsActivateWorkflowModalStore = {
  filters?: IParamsFiltersList
  onPublish?: (
    params: { isEnrollExist: boolean; isReEnroll: boolean },
    withError?: boolean
  ) => Promise<void>
  onCancel?: () => void
}

export class ActivateWorkflowModalStore {
  private _onPublish
  private _onCancel
  constructor(params: IParamsActivateWorkflowModalStore) {
    makeAutoObservable(this)
    this._onPublish = params.onPublish
    this._onCancel = params.onCancel
    this.openModal(params)
  }
  modalId = nanoid()

  contactsCount = 0
  loadingContactsCount = true

  isEnrollExist = false
  setIsEnrollExist = (value: boolean) => {
    this.isEnrollExist = value
  }

  isReEnroll = false
  setIsReEnroll = (value: boolean) => {
    this.isReEnroll = value
  }

  openModal = async (params: IParamsActivateWorkflowModalStore) => {
    try {
      modalStore.addModal({
        id: this.modalId,
        title: 'Review',
        pureContent: true,
        width: 540,
        ModalContent: () => <ActivateWorkflowModalUi store={this} />,
        onClose: this.onClose,
      })

      if (params.filters) {
        const { data } = await ContactsApi.getContactsFiltersCount({
          filtersListGroups: params.filters,
        })
        runInAction(() => {
          this.loadingContactsCount = false
          this.contactsCount = data.count
        })
      }
    } catch (e) {
      logger.error(e)
    }
  }

  onPublish = async () => {
    try {
      await this._onPublish?.({
        isEnrollExist: this.isEnrollExist,
        isReEnroll: this.isReEnroll,
      })
      this._onRemoveModal()
    } catch (e) {
      this._onRemoveModal()
      logger.error(e)
    }
  }

  private _onRemoveModal = () => {
    modalStore.removeModal(this.modalId)
  }

  onClose = () => {
    this._onCancel?.()
    this._onRemoveModal()
  }
}
